import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
import SurveyFormBuilderWorkspace from "./SurveyFormBuilderWorkspace";
import SurveyFormBuilderErrors from "./SurveyFormBuilderErrors";


export default class SurveyFormBuilder extends React.Component {

  constructor(props) {
    super(props)

    var rates
    this.props.rates && this.props.rates.length
      ? rates = this.props.rates.map(rate => rate.id)
      : rates = []
    var products
    this.props.products && this.props.products.length
      ? products = this.props.products.map(product => product.id)
      : products = []


    this.state = { 
      active_tab: 'general',
      id: this.props.id ? this.props.id : '',
      count: this.props.form_fields && this.props.form_fields.length ? this.props.form_fields.length : 0,
      order: [],
      title: this.props.title ? this.props.title : '',
      description: this.props.description ? this.props.description : '', 
      form_fields: this.props.form_fields ? this.props.form_fields : [],
      rates: rates,
      products: products,
      all_survey_forms: this.props.all_survey_forms && this.props.all_survey_forms.length ? this.props.all_survey_forms : [],
      customer_form: this.props.customer_form || false,
      all_form_fields: this.props.all_form_fields || {},
      all_rates: this.props.all_rates && this.props.all_rates.length ? this.props.all_rates : [],
      all_products: this.props.all_products && this.props.all_products.length ? this.props.all_products : [],
      dateFormat: this.props.date_format ? this.props.date_format : "",
      test_email: this.props.test_email ? this.props.test_email : "",
      sendTestEmailPath: this.props.send_test_email_path ? this.props.send_test_email_path : "",
      selected_e: this.props.selected_e ? this.props.selected_e : false,
      selected_r: this.props.selected_r ? this.props.selected_r : false,
      selected_rating: this.props.selected_rating ? this.props.selected_rating : "",
      selected_emoji: this.props.selected_emoji ? this.props.selected_emoji : "",
      rating_answer: this.props.rating_answer ? this.props.rating_answer : null,
      emoji_answer: this.props.emoji_answer ? this.props.emoji_answer : null,
      logo_image_url: this.props.logo_image_url || null

    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onChangeTextField = this.onChangeTextField.bind(this)
    this.onChangeFormFields = this.onChangeFormFields.bind(this)
    this.onChangeSurveyFormFields = this.onChangeSurveyFormFields.bind(this)
    this.onChangeOrder = this.onChangeOrder.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeSelectedRating = this.onChangeSelectedRating.bind(this)
    this.onChangeSelectedEmoji = this.onChangeSelectedEmoji.bind(this)
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this)
  }

  /** Render Functions **/

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]

    return (
      <div className="OrderFormBuilder" ref="form">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons buttons={buttons} />
          <SurveyFormBuilderWorkspace
            {...this.state} 
            onChangeFormFields={this.onChangeFormFields}
            onChangeSurveyFormFields={this.onChangeSurveyFormFields}
            onChangeOrder={this.onChangeOrder}
            onChangeTextField={this.onChangeTextField} 
            onChangeCustomerForm={this.onChangeCustomerForm}
            onChangeRates={this.onChangeRates}
            onChangeProducts={this.onChangeProducts}
            onChangeSelectedRating={this.onChangeSelectedRating} 
            onChangeSelectedEmoji={this.onChangeSelectedEmoji} 
            onChangeFileUploadGroup={this.onChangeFileUploadGroup} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  tabs() {
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: SurveyFormBuilderErrors.generalErrors(this.state.errors).length
        },
        {
          tabName: I18n.t('form_fields'),
          targetName: 'form_fields',
          classes: this.state.active_tab === 'form_fields' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: SurveyFormBuilderErrors.formFieldErrors(this.state.errors).length
        },
        {
          tabName: I18n.t('preview'),
          targetName: 'preview',
          classes: this.state.active_tab === 'preview' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );
  };

   /** Change Handlers **/

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab});
  }

  onChangeOrder(idsInOrder) {
    this.setState({order:idsInOrder})
  }
  
  onChangeTextField(event) {
    if (event && event.target) {
      var state = $.extend(true, {}, this.state);
      state[event.target.name] = event.target.value;
      this.setState(state);
    }
  }

  onChangeSurveyFormFields(event) {
    if (event && event.target) {
      this.setState({form_fields: event.target.value})
     
    }
  }
  onChangeFormFields(e) {
    var answers = this.state.answers
   
      this.state.form_fields.map((field) => {
        if(field.id === e.target.id) {
          var found = false;
          if(answers) {
            for(var i = 0, ilen = answers.length; i < ilen; i++) {
              if (answers[i].form_field_id === e.target.id) {
                found = true;
                break;
              }
            }
          }
          if (found) {
            answers.map(answer => {
              if (answer.form_field_id === e.target.id) {
                if(e.target.name == 'number') {
                  answer.number_answer = e.target.value
                } else if(e.target.name == 'date') {
                  answer.date_answer = e.target.value
                } else {
                  answer.answer = e.target.value
                }
              }
            })
          } else {
            if(!answers) {
              answers = []
            }
            if(e.target.name == 'number') {
              var new_answer = {
                form_field_id: e.target.id,
                number_answer: e.target.value
              }
            } else if (e.target.name == 'date') {
              var new_answer = {
                form_field_id: e.target.id,
                date_answer: e.target.value
              }
            } else {
              var new_answer = {
                form_field_id: e.target.id,
                answer: e.target.value
              }
            }

            answers.push(new_answer)
          }
        }
      })
    
    this.setState({answers: answers})
  }

  onChangeRates(rates) {
    this.setState({rates: rates})
  }

  onChangeProducts(products) {
    this.setState({products: products})
  }

  onChangeSelectedEmoji(rating) {
    this.setState({
      selected_e: !this.state.selected_e,
      selected_emoji: rating
    });
  }

  onChangeSelectedRating(rating) {
    this.setState({
      selected_r: !this.state.selected_r,
      selected_rating: rating
    });
  }

  onChangeFileUploadGroup(file_upload_group) {
    if (file_upload_group) {
      this.setState({
        file_upload_group: file_upload_group,
      })
    }
  }

 
  // /** AJAX Calls **/

  onSubmit() {
    var self = this  
    self.setState({ loading: true})
    setTimeout(function () {
      $.ajax({
        type: self.props.is_new ? 'POST' : 'PATCH',
        url: self.props.is_new ? self.props.create_path : self.props.save_path,
        data: {
          title: self.state.title,
          description: self.state.description,
          customer_form: self.state.customer_form || false,
          form_fields: self.state.form_fields.length > 0 ? JSON.stringify(self.state.form_fields) : [],
          order: self.state.order.length > 0 ? self.state.order : [],
          rates: self.state.rates,
          products: self.state.products, 
          test_email: self.state.test_email
        },
      }).done(function (data) {   
        if (parent && parent.refresh_data) {
          // console.log("R", self.props)
          if (self.props.is_new == true) {
            parent.refresh_data(I18n.t('survey_form_created_successfully'));
          } else {
            parent.refresh_data(I18n.t('survey_form_saved_successfully'));
          }
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal()
        }
      }).catch((data) => {
        if (data && data.responseJSON) {
          self.setState({errors: data.responseJSON, loading: false})
          $('.modal-body').scrollTop(0)
        }
      })
      window.handleAlertSuccess();
    
    }, 1000)
  };
};
